module.exports = __webpack_public_path__ + "img/logout.c31d61e8.svg";